var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload photo",
    clipPath: "url(#clip0_422_5217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.799 3.79775H10.8968L9.79861 2.59759H6.19811V3.79775H9.27054L10.3687 4.99792H12.799V12.1989H3.19769V6.79818H1.99752V12.1989C1.99752 12.859 2.53759 13.3991 3.19769 13.3991H12.799C13.4591 13.3991 13.9992 12.859 13.9992 12.1989V4.99792C13.9992 4.33783 13.4591 3.79775 12.799 3.79775ZM4.99794 8.59843C4.99794 10.2547 6.34213 11.5989 7.99836 11.5989C9.65459 11.5989 10.9988 10.2547 10.9988 8.59843C10.9988 6.9422 9.65459 5.59801 7.99836 5.59801C6.34213 5.59801 4.99794 6.9422 4.99794 8.59843ZM7.99836 6.79818C8.9885 6.79818 9.79861 7.60829 9.79861 8.59843C9.79861 9.58857 8.9885 10.3987 7.99836 10.3987C7.00822 10.3987 6.19811 9.58857 6.19811 8.59843C6.19811 7.60829 7.00822 6.79818 7.99836 6.79818ZM3.19769 3.79775H4.99794V2.59759H3.19769V0.797333H1.99752V2.59759H0.197266V3.79775H1.99752V5.59801H3.19769V3.79775Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_5217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.402,
    height: 14.402,
    fill: "white",
    transform: "translate(0.197266 0.197235)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadPhoto);
export default __webpack_public_path__ + "static/media/uploadPhoto.89eddbb2ff422fc2e1a18c6e4e9c0998.svg";
export { ForwardRef as ReactComponent };